module.exports = __webpack_public_path__ + "550b5fda4a27cfedb7131b1a6e85e748.eot";


//////////////////
// WEBPACK FOOTER
// ./~/clarity-ui/dist/fonts/open-sans-light-italic.eot
// module id = 655
// module chunks = 0